export default "__VITE_ASSET__jYZNp6zO__"